import { useState } from "react";
import {
  FilterValue,
  SelectFilter,
  SelectOption,
  StringFilterValue,
} from "../../types/filter";
import { SelectListView } from "../SelectListView/SelectListView";
import { FilterPill } from "./FilterPill";
import { TrackingProps } from "../../types/component";
import { isCustomPeriodOption } from "../../utils/filter/selectoption";
import { createFilterValueFromSelectOption } from "../../utils/filter/selectfiltervalue";

interface PillSelectProps {
  filter: SelectFilter;
  filterValue: FilterValue;
  selected: StringFilterValue;
  onChange: (option: SelectOption) => void;
  onTriggerFilter: (filterId: string, filterValue?: FilterValue) => void;
  tracking: TrackingProps;
}

export const PillSelect = ({
  filter,
  filterValue,
  selected,
  onChange,
  onTriggerFilter,
  tracking,
}: PillSelectProps) => {
  const [listBoxIsOpen, setListBoxIsOpen] = useState(false);
  return (
    <FilterPill
      filter={filter}
      listBoxIsOpen={listBoxIsOpen}
      setListBoxIsOpen={setListBoxIsOpen}
      selected={filterValue !== filter.defaultValue}
      tracking={{
        ...tracking,
        name: "select_pill",
      }}
    >
      <SelectListView
        prefix="pill"
        filter={filter}
        selected={selected}
        onChange={(option) => {
          if (isCustomPeriodOption(option)) {
            const newFilterValue = createFilterValueFromSelectOption(
              filter.id,
              option
            );

            onTriggerFilter(filter.id, newFilterValue);
          } else {
            onChange(option);
          }

          setListBoxIsOpen(!listBoxIsOpen);
        }}
        isModal={false}
      />
    </FilterPill>
  );
};
